import {
  TransactionType,
  ConsentAgreementFormDataType,
} from '../model/consent.data-type';
import { SetUserConsentAgreement } from '../services/ApiConsent';

export default async function (purpose: any, token?: any) {
  // make sure to add [test = true] props for testing reason
  let isReady = false;
  let reason = '';

  try {
    const formData: ConsentAgreementFormDataType = {
      identifier: 'dummy-mail@pandora.net',
      purposes: [
        {
          Id: purpose?.purposeId,
          TransactionType: TransactionType.accept,
          Version: purpose?.version,
        },
      ],
      test: true,
    };

    if (token) {
      formData.requestInformation = token;
    }

    await SetUserConsentAgreement(formData);

    isReady = true;
  } catch (error: any) {
    console.log(error);

    isReady = false;
    reason = error?.message;
  }

  return [isReady, reason];
}
